// Renommer une clé de schéma d'écriture casse les clients déjà chargés : un
// back-office resté ouvert sur l'ancien bundle JS continue d'envoyer l'ancien nom
// pendant toute la durée de vie de son onglet. On accepte donc l'ancienne clé en
// alias, normalisée vers la nouvelle *avant* la validation — le schéma lui-même ne
// connaît que le nouveau nom, et son type de sortie reste inchangé (contrairement à
// un `.transform()`, qui rendrait la clé obligatoire).
export const renameDeprecatedKey = (deprecatedKey, currentKey) => (value) => {
    if (typeof value !== 'object' || value === null || Array.isArray(value))
        return value;
    const { [deprecatedKey]: deprecated, ...rest } = value;
    if (deprecated === undefined)
        return rest;
    return rest[currentKey] === undefined ? { ...rest, [currentKey]: deprecated } : rest;
};
